import { BrowserMeta } from "./types";

const browserCodes: string[] = [
    "Firefox",
    "SamsungBrowser",
    "Opera",
    "OPR",
    "Trident",
    "Edge",
    "Chromium",
    "Chrome",
    "Safari"
];

const browserNames: { [key: string]: string } = {
    Firefox: "Firefox",
    SamsungBrowser: "Samsung Internet",
    Opera: "Opera",
    OPR: "Opera",
    Trident: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Chrome: "Chrome",
    Safari: "Safari"
};

const browserSortOrder: { [key: string]: number } = browserCodes.reduce(
    (acc, v, i) => ({ ...acc, [v]: i }),
    {}
);

const browserRegExp: any = new RegExp(`(${browserCodes.join("|")})/([^\\s;]+)`, "g");

export function extractBrowserAndVersion(userAgent: string): BrowserMeta {
    const matches = [...userAgent.matchAll(browserRegExp)];
    matches.sort(
        ([, a1]: string[], [, b1]: string[]) => browserSortOrder[a1] - browserSortOrder[b1]
    );
    const match: Array<string> = matches.shift() as string[];
    const [, code, version = ""] = match || [];
    const name = browserNames[code] || "";

    return { name, version };
}
